import { Box } from "@material-ui/core";
import Confetti from "react-confetti";
export const ConfettiAnimation = () => {
    const options = {}
    return (
        <Box position={'absolute'} zIndex={-1} height={"100%"} width={'100%'} display={'flex'} overflow={'hidden'} style={{ background: 'rgba(0,0,0,0.85)' }}>
            <Confetti
                colors={['#fee165']}
                width={window.innerWidth}
                height={window.innerHeight + window.outerHeight}
                gravity={0.1}
            />
        </Box>
    );
};